import React, { Fragment, useRef, useState } from 'react'

import { useRouter } from 'next/router'

import { Col, Row } from 'antd'
// modal
import { Button, Modal } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { Title } from 'shortcuts/Typography'

import useGetAllPromotions from 'data/useGetAllPromotions'
import { getImagePath } from 'utils/imagePath'

import styles from './mediaPromotion.module.scss'
import CardMediaPromotion from '../components/CardMediaPromotion'
import CardMediaVertical from '../components/CardMediaVertical'


function MediaPromotion() {
  const { xs, sm, xl } = useBreakpoint()
  const { push } = useRouter()
  const ParentRef = useRef<any>()
  const {
    data: PromotionDataMainAds,
    isLoading: PromotionDataMainAdsLoading,
    length: PromotionDataMainLength,
  } = useGetAllPromotions(0, 0, [{ id: 'slug', value: 'main-ads' }])
  const {
    data: PromotionDataMiniAds,
    length: PromotionDataMiniLength,
  } = useGetAllPromotions(0, 0, [{ id: 'slug', value: 'mini-ads' }], null, {
    enabled: !PromotionDataMainAdsLoading,
  })

  const handleHeightWidth = (params: string, container: string): any => {
    if (container === 'mini') {
      if (params === 'width') {
        if (!PromotionDataMiniLength) return '0%'
        if (xl) {
          if (!PromotionDataMainLength) return '100%'
          if (PromotionDataMainLength === 1) return '40%'
          return '30%'
        }
        return '100%'
      } else if (params === 'height') {
        if (xl) return ParentRef?.current?.clientHeight
        return '100%'
      }
    } else if (container === 'main') {
      if (params === 'width') {
        if (xl) {
          if (!PromotionDataMiniLength) return '100%'
          if (PromotionDataMainLength === 1) return '60%'
          return '70%'
        }
        return '100%'
      } else if (params === 'class') {
        if (xl) {
          if (!PromotionDataMiniLength) return 'w-6/12 odd:pr-5'
          if (PromotionDataMainLength === 1) return 'w-full pr-5'
          return 'w-6/12 pr-5'
        } else if (xs) {
          return 'w-full'
        }
        if (PromotionDataMainLength === 1) return 'w-full'
        return 'w-6/12 odd:pr-5'
      }
    }
  }

  // modal
  const [isModalOpen, setIsModalOpen] = useState(false)

  const [selectedPromotionIndex, setSelectedPromotionIndex] = useState(null)

  const handleOpenModal = (index) => {
    setSelectedPromotionIndex(index)
    setIsModalOpen(true)
  }

  const handleOk = () => {
    setIsModalOpen(false)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const router = useRouter()
  const title: any = router.isReady ? router.query.title : ''

  const { data = [] } = useGetAllPromotions(
    1,
    1,
    [{ id: 'title', value: title?.split('-').join(' ') }],
    {},
    { enabled: !!title },
  )
  const { data: DataAll = [] } = useGetAllPromotions(1, 10)

  const isFromHighlight = router.query?.from === 'highlight'

  const styleContent = {
    paddingTop: 0,
    paddingBottom: 0,
  }

  return (
    <Fragment>
      <Row
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: '23px',
        }}
      >
        <Col>
          <Title
            style={{
              fontSize: xs ? '20px' : '36px',
              color: '#2C2C2C',
              fontFamily: 'Inter-Bold',
              fontWeight: '700',
            }}
          >
            Media Promosi
          </Title>
        </Col>
      </Row>
      <Row align="top" style={{ display: 'flex' }}>
        <Col
          style={{ width: handleHeightWidth('width', 'main') }}
          ref={ParentRef}
          className={styles.mainCards}
        >
          {PromotionDataMainAds?.map((d) => {
            return (
              <CardMediaPromotion
                key={d?.id}
                title={d?.title}
                img={getImagePath(d?.image)}
                description={d?.shortDesc}
                onClick={() => push(`/promotion/${d?.title}`)}
              />
            )
          })}
        </Col>
        <Col
          style={{
            width: handleHeightWidth('width', 'mini'),
            height: handleHeightWidth('height', 'mini'),
            overflowY: 'auto',
            overflowX: 'hidden',
            marginTop: !xl && 20,
          }}
          className={`${styles.miniCards}`}
        >
          {PromotionDataMiniAds?.map((d, index) => {
            return (
              <CardMediaVertical
                key={d.id}
                img={getImagePath(d?.image)}
                title={d.title}
                onClick={() => handleOpenModal(index)}
                description={d.shortDesc}
              />
            )
          })}
        </Col>
        <Modal
          title={
            selectedPromotionIndex !== null
              ? PromotionDataMiniAds[selectedPromotionIndex]?.title
              : ''
          }
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={[
            <Button key="cancel"></Button>,
            <Button key="ok" type="primary" onClick={handleOk}>
              OK
            </Button>,
          ]}
        >
          {selectedPromotionIndex !== null &&
            PromotionDataMiniAds[selectedPromotionIndex] && (
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    PromotionDataMiniAds[selectedPromotionIndex].description,
                }}
              ></div>
            )}
        </Modal>
      </Row>
    </Fragment>
  )
}

export default MediaPromotion
